import { Injectable } from '@angular/core';
import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@app/models/core/model-factory';
import { TaskTemplate } from '@app/models/tasks/task-template.model';
import { Task } from '@app/models/tasks/task.model';
import { Department } from '@models/company/department.model';
import { Employee } from '@models/employee/employee.model';

@Injectable()
export class EmployeesResolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'employee',
            production: {
                find: (id: number) => {
                    return Employee.param('company', this.companyId)
                        .with([
                            'account',
                            'address',
                            'job',
                            'department',
                            'office',
                            'manager',
                            'leaveOfAbsences',
                            'assignedTasks',
                            'activeModuleAssignments.module',
                            'activeTimeOffPolicies',
                            'activeTimeOffPolicies.timeOffType',
                            'activeTimeOffPolicies.timeOffRequestRule',
                            'activeTimeOffPolicies.timeOffSeniorityOverrides',
                            'allAssignedTimeOffPolicies',
                            'allAssignedTimeOffPolicies.timeOffType',
                            'allAssignedTimeOffPolicies.timeOffRequestRule',
                            'allAssignedTimeOffPolicies.timeOffSeniorityOverrides',
                            'benefitPlans',
                            'benefitPlans.benefitPlan',
                            'employeeNamePronunciation',
                            'employeeNamePronunciation.file',
                        ])
                        .find(id);
                },
            },
        },
        {
            className: 'department',
            production: {
                find: (id: number) => {
                    return Department.param('company', this.companyId).find(id);
                },
            },
        },
        {
            className: 'taskTemplate',
            production: {
                find: (id: number) => {
                    return TaskTemplate.with([
                        'employeeFilter.filterCriteria.criteriable',
                        'assignees',
                        'subtasks',
                    ]).find(id);
                },
            },
        },
        {
            className: 'task',
            production: {
                find: (id: number) => {
                    return Task.with([
                        'assignee',
                        'subject',
                        'file',
                        'employeeDocument',
                        'completedBy',
                        'assignees',
                        'subtasks',
                    ]).find(id);
                },
            },
        },
    ]);
}
